export const menuItems = [
    {
        id: 1,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "/",
        auth: "admin|dealer|tech|callcenter|personel"
    },
    {
        id: 2,
        label: "menuitems.users.text",
        icon: "bx-user",
        auth: "admin|dealer|personel|callcenter",  
        key:'musteri-islemleri',
        subItems: [
            {
                id: 3,
                label: "menuitems.users.subs.search",
                link: "/musteri-ara",
                parentId: 2,
                key: 'musteri-ara',
                auth: "admin|dealer|personel"
            },
            {
                id: 4,
                label: "menuitems.users.subs.create",
                link: "/on-kayit-ekle",
                parentId: 2,
                key: 'musteri-ekle',
                auth: "admin|dealer|personel|callcenter"
            },
            {
                id: 63,
                label: "menuitems.users.subs.uzatmayanlar",
                link: "/uzatmayanlar",
                parentId: 2,
                key: 'uzatmayanlar',
                border:"top",
                auth: "admin|dealer|personel"
            },
            {
                id: 51,
                label: "menuitems.users.subs.sokum",
                link: "/sokum-listesi",
                key:'sokum-listesi',
                parentId: 2,
                auth: "admin|personel"
            },
            {
                id: 65,
                label: "menuitems.users.subs.sokulemeyen",
                link: "/sokulemeyen-listesi",
                auth: "admin|personel",
                parentId: 29,
                key: "sokulemeyen-listesi",
            },
            {
                id: 64,
                label: "menuitems.users.subs.kayip",
                link: "/kayip-listesi",
                auth: "admin|personel",
                parentId: 29,
                border:"bottom",
                key: "kayip-listesi",
            },
            {
                id: 47,
                label: "menuitems.users.subs.kurulum_bekleyenler",
                link: "/kurulum-bekleyenler",
                parentId: 2,
                key: 'kurulum_bekleyenler',
                auth: "admin|dealer|personel"
            },
            {
                id: 52,
                label: "menuitems.users.subs.ariza",
                link: "/ariza-listesi",
                parentId: 2,
                key:'ariza-listesi',
                auth: "admin|personel"
            },
            {
                id: 71,
                label: "menuitems.users.subs.tasima",
                link: "/tasima-listesi",
                parentId: 2,
                key:'tasima-listesi',
                auth: "admin|personel"
            },
            {
                id: 54,
                label: "menuitems.sett.subs.apartmant",
                link: "/apartman-yonetimi",
                parentId: 2,
                key:'apartman-yonetimi',
                auth: "admin|personel"
            },
            {
                id: 30,
                label: "menuitems.tech.subs.list",
                link: "/is-listesi",
                auth: "admin|tech|personel",
                parentId: 29,
                key: "is-listesi",
            },
            {
                id: 74,
                label: "menuitems.users.subs.kurulamayan",
                link: "/kurulamayanlar-listesi",
                auth: "admin|tech|personel",
                parentId: 29,
                key: "kurulamayanlar-listesi",
            },
        ]
    },  
    {
        id: 60,
        label: "menuitems.muhasebe.text",
        icon: "bx-money",
        auth: "admin",
        key: "muhasebe",
        subItems: [
            {
                id: 61,
                label: "menuitems.muhasebe.genel",
                link: "/muhasebe-genel",
                key: "muhasebe-genel",
				auth: "admin",
                parentId: 60
            },
            {
                id: 62,
                label: "menuitems.muhasebe.sahsi",
                link: "/muhasebe-sahsi",
                key:"muhasebe-sahsi",
				auth: "admin",
                parentId: 60
            },
            {
                id: 76,
                label: "menuitems.muhasebe.ara",
                link: "/fatura-makbuz-ara",
                key:"fatura-makbuz-ara",
				auth: "admin",
                parentId: 60
            },
        ]
    },
	{
        id: 11,
        label: "menuitems.dealer.text",
        icon: "bxs-cake",
        auth: "admin|personel",
        key: "bayi-yonetimi",
        subItems: [
            {
                id: 57,
                label: "menuitems.dealer.subs.bakiye",
                link: "/bayi-bakiye-hareket",
                parentId: 11,
                auth: "admin|personel",
                key: "bayi-bakiye-hareket"
            },
            {
                id: 67,
                label: "menuitems.dealer.subs.tahsilat",
                link: "/bayi-tahsilatlari",
                parentId: 11,
                auth: "admin|personel",
                key: "bayi-tahsilatlari"
            },
            {
                id: 73,
                label: "menuitems.dealer.subs.personel",
                link: "/bayi-tahsilatlari-personel",
                auth: "admin",
                key:'bayi-tahsilatlari-personel',
                parentId: 11
            },
            {
                id: 12,
                label: "menuitems.dealer.subs.list",
                link: "/bayi-listesi",
                auth: "admin",
                key:'bayi-listesi',
                parentId: 11
            }
        ]
    },
    {
        id: 18,
        label: "menuitems.network.text",
        icon: "bx bx-wifi",
        auth: "admin",
        key: "network",
        subItems: [
			{
                id: 20,
                label: "menuitems.network.subs.router",
                link: "/network/router-yonetimi",
                parentId: 18,
                key: "router-yonetimi",
            },
            {
                id: 21,
                label: "menuitems.network.subs.verici",
                link: "/network/verici-yonetimi",
                parentId: 18,
                key: "verici-yonetimi",
            },
            {
                id: 22,
                label: "menuitems.network.subs.ip",
                link: "/network/ip-yonetimi",
                parentId: 18,
                key: "ip-yonetimi",
            },
            {
                id: 72,
                label: "menuitems.network.subs.hata",
                link: "/network/hata-yonetimi",
                parentId: 18,
                key: "hata-yonetimi",
            },
        ]
    },
    {
        id: 18,
        label: "menuitems.stock.text",
        icon: "bx bx-package",
        auth: "admin|tech|personel",
        key: "stock",
        subItems: [
			{
                id: 20,
                label: "menuitems.stock.subs.list",
                link: "/stok-yonetimi",
                parentId: 18,
                key: "stok-yonetimi",
                auth: "admin|tech|personel",
            },
            {
                id: 69,
                label: "menuitems.stock.subs.depo",
                link: "/depo-yonetimi",
                parentId: 18,
                key: "depo-yonetimi",
                auth: "admin|personel",
            },
            {
                id: 70,
                label: "menuitems.stock.subs.urun",
                link: "/urun-yonetimi",
                parentId: 18,
                key: "urun-yonetimi",
                auth: "admin|personel",
            },
        ]
    },
    {
        id: 38,
        label: "menuitems.report.text",
        icon: "bx bx-line-chart",
        auth: "admin|dealer|personel",
        key: "raporlar",
        subItems: [
            {
                id: 59,
                label: "menuitems.report.extre",
                link: "/extre-raporu",
                parentId: 11,
                key:'extre-raporu',
                auth: "admin|personel|dealer",
            },
            { 
                id: 49,
                label: "menuitems.report.musteri_listesi",
                link: "/musteri-listesi",
                parentId: 38,
                key:'musteri-listesi',
                auth: "admin|dealer|personel",
            },
            { 
                id: 43,
                label: "menuitems.report.musteri_sayisi",
                link: "/musteri-sayisi",
                parentId: 38,
                key:'musteri-sayisi',
                auth: "admin|dealer",
            },
            {
                id: 39,
                label: "menuitems.report.is_listesi",
                link: "/is-listesi-raporu",
                parentId: 38,
                key:'is-listesi-raporu',
                auth: "admin|personel",
            },
            {
                id: 42,
                label: "menuitems.report.subs.traffic",
                link: "/trafik",
                parentId: 38,
                key:'trafik',
                auth: "admin|dealer",
            },
            {
                id: 55,
                label: "menuitems.report.musteri_bakiye_fark_listesi",
                link: "/musteri-bakiye-fark-listesi",
                parentId: 11,
                key:  "musteri-bakiye-fark-listesi",
                auth: "admin",
            },
            { 
                id: 68,
                label: "menuitems.report.subs.islemler",
                link: "/islem-gecmisleri",
                parentId: 38,
                key: "islem-gecmisleri",
                auth: "admin",
            },
            { 
                id: 77,
                label: "menuitems.report.subs.taksitliler",
                link: "/taksitliler",
                parentId: 38,
                key: "taksitliler",
                auth: "admin",
            },
        ]
    },
    {
        id: 23,
        label: "menuitems.sett.text",
        icon: "bx bx-cog",
        key:'sistem',
        auth: "admin|dealer|tech|callcenter|personel",
        subItems: [
            {
                id: 24,
                label: "menuitems.sett.subs.panel",
                link: "/ayarlar/panel-ayarlari",
                parentId: 23,
                key:'panel-ayarlari',
                auth: "admin|dealer|tech|callcenter|personel",
            },
			{
                id: 25,
                label: "menuitems.sett.subs.users",
                link: "/kullanici-yonetimi",
                parentId: 23,
                key:'kullanici-yonetimi',
                auth: "admin"
            },
            {
                id: 75,
                label: "menuitems.sett.subs.yetkilendirme",
                link: "/yetkilendirmeler",
                parentId: 23,
                key:'yetkilendirmeler',
                auth: "admin"
            },
            {
                id: 26,
                label: "menuitems.packets.text",
                link: "/tarife-yonetimi",
                parentId: 23,
                key:'tarife-yonetimi',
                auth: "admin"
            },
            {
                id: 66,
                label: "menuitems.sett.subs.sms",
                link: "/sms-yonetimi",
                parentId: 23,
                key:'sms-yonetimi',
                auth: "admin"
            },
            {
                id: 999,
                label: "menuitems.sett.subs.cikis",
                link: "/logout",
                parentId: 23,
            },
        ]
    },
];

